import React from "react";
import uploadUserProfile from "../../../../styles/svg/update_user_profile.svg";
import { Stack } from "@mui/material";

import AvatarImage from "../../../../components/Avatar";
import { createAvtarName } from "../../../../utils";

export const UserAvatar = React.memo(({
  preview,
  profileData,
  fileInputRef,
  handleFileChange,
}) => {
  const fullName =
    profileData?.user?.first_name + " " + profileData?.user?.last_name;

  return (
    <Stack alignItems={"center"} className="user-profile-avatar-container">
      <AvatarImage
        username={fullName}
        user_image={preview}
        title={fullName}
        className="user-profile-avatar"
        unassigned={true}   
      >
        {createAvtarName(fullName)}
      </AvatarImage>

      <img
        src={uploadUserProfile}
        alt="update profile"
        className="userUploadProfileIcon"
        onClick={() => fileInputRef.current.click()}
        style={{ cursor: "pointer" }}
      />
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <p className="user-profile-edit-text mt-2">
        Click the edit icon to upload a new profile picture
      </p>
    </Stack>
  );
});
